$(function(){
    $(".nav_mb").click(function(e){
        e.stopPropagation();
        $(".nav_mb").toggleClass("active")
        $(".nav_mb_menu").toggleClass("active")
    })
    $(".nav_mb_menu .site-nav__item  .site-nav__link").click(function(){
        $(".nav_mb").removeClass("active")
        $(".nav_mb_menu").removeClass("active")
    })
   $(".nav_mb_menu .site-nav__item  .site-nav__dropdown-link").click(function(){
        $(".nav_mb").removeClass("active")
        $(".nav_mb_menu").removeClass("active")
    })
   $(".nav_mb_menu .site-nav__title").click(function(e){
        e.stopPropagation();
        $(this).parent().toggleClass("active")
    })

    // $(window).click(function(event){
    //     console.log(event.target ,$(".nav"));
    //      if(event.target != $('.nav').get(0) ){
    //          $(".nav").removeClass("active")
    //      }
           
    //  });
    
    
})